import { cardsItems } from '@/mocks/home';

const cardsImages = [
  'https://readdy.ai/api/search-image?query=Television%20studio%20accident%20dramatic%20scene%20abstract%20illustration%2C%20warm%20dark%20background%20with%20coral%20accents%2C%20entertainment%20industry%20behind%20scenes%2C%20editorial%20style%2C%20dramatic%20lighting%2C%20modern%20clean%20design&width=800&height=500&seq=cards-718-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Live%20streaming%20fail%20moments%20compilation%20abstract%20illustration%2C%20warm%20amber%20and%20dark%20tones%2C%20social%20media%20entertainment%20concept%2C%20editorial%20style%2C%20dramatic%20atmosphere%2C%20modern%20clean%20composition&width=800&height=500&seq=cards-718-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Nostalgic%20entertainment%20gossip%20memories%20abstract%20illustration%2C%20warm%20dark%20background%20with%20teal%20secondary%20accents%2C%20retro%20vibe%2C%20editorial%20design%2C%20soft%20dramatic%20lighting%2C%20modern%20clean%20composition&width=800&height=500&seq=cards-718-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Celebrity%20downfall%20scandal%20abstract%20illustration%2C%20warm%20dark%20background%20with%20coral%20and%20gold%20accents%2C%20entertainment%20news%20concept%2C%20editorial%20style%2C%20dramatic%20lighting%2C%20modern%20clean%20design&width=800&height=500&seq=cards-718-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Fake%20news%20detection%20tips%20abstract%20illustration%2C%20warm%20dark%20background%20with%20amber%20highlights%2C%20educational%20editorial%20style%2C%20magnifying%20glass%20concept%2C%20modern%20clean%20composition&width=800&height=500&seq=cards-718-05&orientation=landscape',
];

const tagColors: Record<string, string> = {
  '综艺': 'bg-primary-100 text-primary-700',
  '盘点': 'bg-accent-100 text-accent-700',
  '回顾': 'bg-secondary-100 text-secondary-700',
  '技巧': 'bg-accent-100 text-accent-700',
};

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              编辑精选的优质内容，吃瓜不再迷路
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cardsItems.map((item, i) => (
              <article
                key={i}
                className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={cardsImages[i]}
                    alt={item.title}
                    title={`黑料718 - ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-col flex-grow p-4 md:p-5">
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 flex-grow line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>
                    <span>{item.reads} 阅读</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}